type menuItemAction<T> = (
  record: T,
  callBackfn?: () => void
) => void | React.ReactNode | JSX.Element | any;

export class MenuItem<T> {
  name: string;
  onClick?: menuItemAction<T>;
  icon?: JSX.Element;
  disabled?: boolean;

  constructor(
    name: string,
    action?: menuItemAction<T>,
    icon: JSX.Element | any = "",
  ) {
    this.name = name;
    this.onClick = action;
    this.icon = icon;
  }
}
